export const onboardingRoutePath = '/onboarding';
